import { Record } from "immutable";

export const ManagerTopStat = new Record({
  manager_kpi: 0,
  manager_percent_new: 0,
  manager_percent_other: 0,
  manager_salary: 0,
  profit_new: 0,
  profit_other: 0,
  manager_profit: 0,
  system_profit_new: 0,
  salary_profit_new: 0
});
